module.exports = __webpack_public_path__ + "static/media/sensable_13.19ad6422.gif";